import React, { useRef, useState } from "react";
import speakerHeroBg from "../../assets/BG-3.png";
import calendarIcon from "../../assets/Calendar.svg";
import pinIcon from "../../assets/Pin.svg";
import clockIcon from "../../assets/Clock.svg";
import ImageGallery from "./ImageGallery";
// import checkIcon from "../../assets/Check.svg";
// import micIcon from "../../assets/Mic.svg";
// import starIcon from "../../assets/Star.svg";
import irwinPhoto from "../../assets/Irwin.png";
import charlesPhoto from "../../assets/charles.png";
import riaPhoto from "../../assets/ria.png";
import manuelPhoto from "../../assets/manuel.png";
import saddamPhoto from "../../assets/saddam.png";
import prakashPhoto from "../../assets/prakash.png";
import dominicPhoto from "../../assets/dominic.png";
// import placeholderPhoto from "../../assets/placeholder.png";
// import pmPhoto from "../../assets/primeminister.png";
// import closingCardBg from "../../assets/BG-2.png";
import { Header } from "../PageTemplate/Header";
import { Footer } from "../PageTemplate/Footer";
import "../PublicationsPage/PublicationsPage.css";
import trustBg from "../../assets/BG-2.png";
import demoImg from "../../assets/Demoimg.png";
import sherwinPhoto from "../../assets/sherwin.png";
import articleImg1 from "../../assets/article-img-1.jpg";
import articleImg2 from "../../assets/article-img-2.jpg";
import articleImg3 from "../../assets/article-img-3.jpg";
import articleImg4 from "../../assets/article-img-4.png";
import articleImg5 from "../../assets/article-img-5.jpg";
import articleImg6 from "../../assets/article-img-6.jpg";
import articleImg7 from "../../assets/article-img-7.jpg";
import articleImg8 from "../../assets/article-img-8.jpeg";
import articleImg9 from "../../assets/article-img-9.png";

const SpeakerPage = () => {
	const agendaSectionRef = useRef(null);
	const [carouselIndex, setCarouselIndex] = useState(0);

	const eventDetails = [
		{
			icon: calendarIcon,
			alt: "Calendar",
			label: "Wednesday 22nd April 2026",
		},
		{ icon: pinIcon, alt: "Location", label: "Hyatt Regency" },
		{ icon: clockIcon, alt: "Time", label: "10:00 a.m." },
	];

	// const launchHighlights = [
	// 	{
	// 		icon: checkIcon,
	// 		alt: "Purpose icon",
	// 		title: "A Product Launch With Purpose",
	// 		description:
	// 			"Discover why VerifyTT is launching now, the problem it is solving, and the role it can play in trusted digital credentials.",
	// 	},
	// 	{
	// 		icon: micIcon,
	// 		alt: "Voices icon",
	// 		title: "Voices Shaping The Launch",
	// 		description:
	// 			"Hear from public-sector leaders, product teams, and ecosystem partners helping move this work forward.",
	// 	},
	// 	{
	// 		icon: starIcon,
	// 		alt: "Sessions icon",
	// 		title: "Sessions Worth Attending",
	// 		description:
	// 			"Explore keynote remarks, product moments, and focused conversations around verification, trust, and implementation.",
	// 	},
	// ];

	const speakerLineup = [
		{
			id: 1,
			name: "Senator the Honourable Dominic Smith",
			role: "Minister of Public Administration and AI",
			organization: "",
			description: "",
			image: dominicPhoto,
		},
		{
			id: 2,
			name: "Senator The Honourable Professor Prakash Persad",
			role: "Minister of Tertiary Education and Skills Training",
			organization: "",
			description: "",
			image: prakashPhoto,
		},
		{
			id: 3,
			name: "The Honourable Saddam Hosein M.P.",
			role: "Minister of Land and Legal Affairs and Minister in the Ministry of Agriculture and Fisheries",
			organization: "",
			description: "",
			image: saddamPhoto,
		},
		{
			id: 4,
			name: "Ms. Ria Karim",
			role: "Chairman, iGovTT",
			organization: "",
			description: "",
			image: riaPhoto,
		},
		{
			id: 5,
			name: "Mr Charles Bobb-Semple",
			role: "CEO (Ag), iGovTT",
			organization: "",
			description: "",
			image: charlesPhoto,
		},
		{
			id: 6,
			name: "Sherwin Ragoonanan",
			role: "Deputy CEO (Ag), iGovTT",
			organization: "",
			description: "",
			image: sherwinPhoto,
		},
		{
			id: 7,
			name: "Irwin Williams",
			role: "Head, Software Development, iGovTT",
			organization: "",
			description: "",
			image: irwinPhoto,
		},

		{
			id: 8,
			name: "Mr. Manuel Aguillera",
			role: "Senior Regional Lead for Latin America and the Caribbean, CDPI",
			organization: "",
			description: "",
			image: manuelPhoto,
		},
	];

	const launchAgenda = [
		{
			number: "01",
			time: "",
			title: "Welcome Remarks",
			description: "Mr Charles Bobb-Semple CEO (Ag), iGovTT",
		},
		{
			number: "02",
			time: "",
			title: "Chairman's Remarks",
			description: "Ms. Ria Karim Chairman, iGovTT",
		},
		{
			number: "03",
			time: "",
			title: "Guest Speaker Remarks",
			description:
				"Manuel Aguilera Senior Regional Lead for Latin America and the Caribbean, CDPI",
		},
		{
			number: "04",
			time: "",
			title: "Remarks",
			description:
				"Senator Professor the Honourable Prakash Persad, Minister of Tertiary Education",
		},
		{
			number: "05",
			time: "",
			title: "Demonstration",
			description: "Irwin Williams Head, Software Development, iGovTT",
		},
		{
			number: "06",
			time: "",
			title: "Remarks",
			description:
				"The Honourable Saddam Hosein M.P., Minister of Land and Legal Affairs",
		},
		{
			number: "07",
			time: "",
			title: "Feature Address",
			description:
				"Senator the Honourable Dominic Smith, Minister of Public Administration and AI",
		},
		{
			number: "08",
			time: "",
			title: "First Memorandum of Understanding as it pertains to the Ministry of Land and Legal Affairs",
			// description:
			// 	"The Honourable Dominic Smith, Minister of Public Administration and Artificial Intelligence, The Honourable Saddam Hosein, Minister of Land and Legal Affairs and Minister in the Ministry of Agriculture and Fisheries, Ms. Karen Bridgewater, Registrar General, Registrar General's Department, The Ministry of Land and Legal Affairs, Ms. Ria Karim, Chairman of the Board of Directors, iGovTT, Mr. Charles Bobb-Semple, Acting CEO of iGovTT",
		},
		{
			number: "08",
			time: "",
			title: "Second Memorandum of Understanding as it pertains to the TTPS ",
			// description:
			// 	"Senator the Honourable Dominic Smith, Minister of Public Administration and Artificial Intelligence, Ms. Natasha George, Deputy Comissioner of Police for and on behalf of Mr. Allister Guevarro, Comissioner of Police, Trinidad and Tobago Police Service, Ms. Ria Karim, Chairman of the Board of Directors, iGovTT, Mr. Charles Bobb-Semple, Acting CEO of iGovTT",
		},
		{
			number: "09",
			time: "",
			title: "Panel Discussion: 'Building Trust in the Digital Age with Verifiable Credentials'",
			// description:
			// 	"Senator the Honourable Dominic Smith, Minister of Public Administration and Artificial Intelligence, Mr. Ugo Blanco - Resident Representative, Trinidad and Tobago, Aruba, Curacao and Saint Maarten, United Nations Development Programme UNDP, Mr. Manuel Aguilera, Senior Regional Lead, Latin America & the Caribbean, Centre for Digital Public Infrastructure (CDPI), Mr. Anish Bachu, Head of Trinidad and Tobago’s Cyber Security Incident Response Team, Ministry of Homeland Security, Mr. Yash Koli, Associate Director, Technology & Transformation Business, Deloitte",
		},
		{
			number: "10",
			time: "",
			title: "VOTE OF THANKS",
			description: "Sherwin Ragoonanan, Deputy CEO (Ag), iGovTT",
		},
	];

	const pressArticles = [
		{
			tag: "TTT News",
			date: "April 22, 2026",
			title: "New Digital Platform VerifyTT Set To Transform Access To Public Records",
			excerpt:
				"Trinidad and Tobago launched VerifyTT, a digital public infrastructure platform providing citizens instant access to official records — eliminating physical paperwork and long government office queues.",
			href: "https://www.ttt.live/new-digital-platform-verifytt-set-to-transform-access-to-public-records/",
			image: articleImg1,
		},
		{
			tag: "GovInsider",
			date: "April 22, 2026",
			title: "Trinidad and Tobago Flips the DPI Script by Starting With Credentials Launch",
			excerpt:
				"The initiative uniquely prioritizes digital credentials before establishing a foundational digital ID system, beginning with academic and employment credentials accessible via a mobile wallet.",
			href: "https://govinsider.asia/intl-en/article/trinidad-and-tobago-flips-the-dpi-script-by-starting-with-credentials-launch",
			image: articleImg2,
		},
		{
			tag: "Biometric Update",
			date: "April 27, 2026",
			title: "Trinidad and Tobago Launches Digital Credentials Platform in DPI Push",
			excerpt:
				"VerifyTT enables institutions to issue cryptographically signed credentials that citizens can store in mobile wallets and share globally, as part of the nation's broader Digital Public Infrastructure commitment.",
			href: "https://www.biometricupdate.com/202604/trinidad-and-tobago-launches-digital-credentials-platform-in-dpi-push",
			image: articleImg3,
		},
		{
			tag: "CCN TV6",
			date: "April 22, 2026",
			title: "Gov't Launches VerifyTT",
			excerpt:
				"The application process for submitting credentials when pursuing a new job just got easier. It comes with the government's launch of VerifyTT, which was done in partnership with India.",
			href: "https://www.tv6tnt.com/news/7pmnews/govt-launches-verify-tt/article_29ec0af4-80d1-457d-99d5-f632d8787b0d.html",
			image: articleImg4,
		},
		{
			tag: "103 FM",
			date: "April 22, 2026",
			title: "Government Launches VerifyTT",
			excerpt:
				"Government has launched Verify TT, a secure mobile wallet and new digital platform it says will provide a secure, and instantly verifiable digital record.",
			href: "https://103fm.tt/news/government-launches-verify-tt/",
			image: articleImg5,
		},
		{
			tag: "AZP News",
			date: "April 22, 2026",
			title: "Government Rolls Out VerifyTT to Cut Red Tape and Modernise Public Services",
			excerpt:
				"Trinidad and Tobago has officially launched VerifyTT, a foundational digital platform designed to provide citizens with secure, seamless, and faster access to government services.",
			href: "https://azpnews.com/government-rolls-out-verifytt-to-cut-red-tape-and-modernise-public-services/",
			image: articleImg6,
		},
		{
			tag: "Tech News TT",
			date: "April 22, 2026",
			title: "VerifyTT Lays a Foundation Stone for Digital Identity",
			excerpt:
				"VerifyTT hopes to revolutionize document handling by establishing trust in digital documents across the governance ecosystem",
			href: "https://technewstt.com/verifytt-lays-a-foundation-stone-for-digital-identity/",
			image: articleImg7,
		},
		{
			tag: "TTT News",
			date: "April 22, 2026",
			title: "New Digital Platform VerifyTT Set To Transform Access To Public Records",
			excerpt:
				"Trinidad and Tobago will officially be stepping away from the “brown envelope” era.",
			href: "https://www.ttt.live/ttps-welcomes-verifytt-initiative-as-major-step-in-digital-transformation/?fbclid=IwZnRzaARgwjtleHRuA2FlbQIxMQBzcnRjBmFwcF9pZAo2NjI4NTY4Mzc5AAEehBHcEMkwRCoJBl5PoXh3KqpiVUdqTtjMha8cT66jhdPQAFfB3xTnOyJQlzE_aem_Cdu86Rt4DPyOz-Ks87WUdg",
			image: articleImg8,
		},
		{
			tag: "Ministry of Public Administration",
			date: "April 22, 2026",
			title: "VerifyTT Launched as Government Accelerates Digital Transformation Agenda",
			excerpt:
				"The Ministry of Public Administration and Artificial Intelligence announced the official launch of VerifyTT, underscoring the Government's commitment to accelerating digital transformation and improving service delivery.",
			href: "https://mpaai.gov.tt/media-releases/verifytt-launched-government-accelerates-digital-transformation-agenda",
			image: articleImg9,
		},
	];

	const albumContext = require.context(
		"../../album",
		false,
		/\.(jpe?g|png|webp)$/i,
	);
	const eventGalleryImages = albumContext
		.keys()
		.sort()
		.map((key) => ({ src: albumContext(key) }));

	const handleExploreAgendaClick = () => {
		agendaSectionRef.current?.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	};

	return (
		<div
			style={{ margin: 0, padding: 0, background: "#F8FAFC", zoom: 0.97 }}
		>
			<div
				style={{
					width: "100%",
					minHeight: "100%",
					background: "#F8FAFC",
					overflow: "visible",
					flexDirection: "column",
					justifyContent: "flex-start",
					alignItems: "flex-start",
					display: "inline-flex",
				}}
			>
				<Header />

				<main className="w-full" aria-label="Speaker page content">
					{/* <section
						className="flex w-full justify-center px-4 pb-16 pt-10 sm:px-6 sm:pb-20 lg:px-8 lg:pb-24"
						aria-label="Speaker launch hero"
					>
						<div
							className="relative w-full max-w-[1204px] overflow-hidden rounded-[28px] border border-[#34405D] bg-[#08111F] bg-cover bg-center bg-no-repeat shadow-[0_16px_40px_rgba(15,23,42,0.16)]"
							style={{ backgroundImage: `url(${speakerHeroBg})` }}
						>
							<div className="relative z-10 flex min-h-[520px] items-center px-6 py-10 sm:px-8 sm:py-12 lg:min-h-[640px] lg:px-12 lg:py-14 xl:px-14">
								<div className="max-w-[760px]">

									<h1 className="mb-0 mt-8 max-w-[760px] text-[61px] font-bold leading-[0.98] tracking-[-0.03em] text-white">
										The{" "}
										<span className="text-[#387FF5]">
											speakers
										</span>
										<br />
										who led the launch of
										<br />
										VerifyTT
									</h1>
									<p className="mb-0 mt-6 max-w-[700px] text-[16px] leading-[1.5] text-white">
										Hear from the leaders, product voices,
										and ecosystem partners who introduced
										VerifyTT and the opportunity behind it
										on April 22nd, 2026.
									</p>

									<div className="mt-8 flex flex-wrap gap-3">
										{eventDetails.map(
											({ icon, alt, label }) => (
												<div
													key={label}
													className="inline-flex min-h-[40px] items-center gap-3 rounded-full border border-white/12 bg-white/6 px-4 py-2 text-[14px] font-medium text-white bg-white/10"
												>
													<span className="flex h-5 w-5 items-center justify-center shrink-0">
														<img
															src={icon}
															alt={alt}
															className="h-[17px] w-[17px] object-contain"
														/>
													</span>
													<span>{label}</span>
												</div>
											),
										)}
									</div>

									<div className="mt-12 flex flex-wrap gap-4">
										<button
											type="button"
											onClick={handleExploreAgendaClick}
											className="inline-flex min-h-[50px] items-center justify-center rounded-[10px] border border-white bg-white px-7 py-3 text-[16px] font-semibold text-[#1A2236] shadow-[0_10px_22px_rgba(255,255,255,0.08)] transition-all hover:bg-[#F4F7FB]"
										>
											View Agenda
										</button>
									</div>
								</div>
							</div>
						</div>
					</section> */}

					{/* ── IN THE PRESS ── */}
					<section
						className="flex w-full justify-center mt-[60px] mb-[60px] px-4 sm:px-6 lg:px-8"
						aria-label="In the press"
					>
						<div className="w-full max-w-[1204px]">
							<span className="inline-flex w-fit items-center rounded-full border border-white/10 bg-[rgba(128,151,208,0.12)] px-4 py-2 text-[14px] font-semibold uppercase tracking-[0.02em] text-[#56BCF8] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] mb-6">
								VerifyTT Launch Recap
							</span>
							<div className="w-full rounded-[24px] overflow-hidden bg-[#0D1526] px-6 py-12 sm:px-10 sm:py-16 lg:px-14 lg:py-20">
								<div className="max-w-[900px] mb-10">
									<p className="m-0 text-[16px] font-semibold uppercase tracking-widest text-[#56BCF8]">
										In the Press
									</p>
									<h2 className="mb-0 mt-4 text-[36px] font-bold leading-[1.08] tracking-[-0.03em] text-white">
										What people are saying about VerifyTT
									</h2>
								</div>

								{/* Carousel track */}
								<div className="overflow-hidden">
									<div
										className="flex transition-transform duration-500 ease-in-out"
										style={{
											transform: `translateX(-${carouselIndex * 100}%)`,
										}}
									>
										{Array.from({
											length: Math.ceil(
												pressArticles.length / 3,
											),
										}).map((_, pageIdx) => (
											<div
												key={pageIdx}
												className="min-w-full grid grid-cols-1 gap-6 sm:grid-cols-3"
											>
												{pressArticles
													.slice(
														pageIdx * 3,
														pageIdx * 3 + 3,
													)
													.map(
														({
															tag,
															date,
															title,
															excerpt,
															href,
															image,
														}) => (
															<a
																key={title}
																href={href}
																target="_blank"
																rel="noreferrer"
																aria-label={`Read full post: ${title}`}
																className="flex flex-col rounded-[18px] overflow-hidden bg-[#131F35] border border-[#1E2E4A] no-underline transition-all duration-200 hover:border-[#387FF5] hover:shadow-[0_8px_24px_rgba(56,127,245,0.12)] cursor-pointer"
															>
																<div className="relative h-[200px] w-full overflow-hidden">
																	<img
																		src={
																			image
																		}
																		alt={
																			title
																		}
																		className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
																	/>
																	<span className="absolute top-4 left-4 inline-flex items-center rounded-full bg-[rgba(56,127,245,0.18)] border border-[rgba(56,127,245,0.3)] px-3 py-1 text-[12px] font-semibold text-[#56BCF8] backdrop-blur-sm">
																		{tag}
																	</span>
																</div>
																<div className="flex flex-col flex-1 p-6 gap-3">
																	<p className="m-0 text-[13px] text-white/40">
																		{date}
																	</p>
																	<h3 className="m-0 text-[20px] font-bold leading-[1.22] tracking-[-0.02em] text-white">
																		{title}
																	</h3>
																	<p className="m-0 text-[14px] leading-[1.6] text-white/60 flex-1">
																		{
																			excerpt
																		}
																	</p>
																	<span className="mt-2 inline-flex items-center gap-1 text-[14px] font-medium text-white/50 transition-colors group-hover:text-white">
																		Read
																		full
																		post{" "}
																		&#8594;
																	</span>
																</div>
															</a>
														),
													)}
											</div>
										))}
									</div>
								</div>

								{/* Carousel controls */}
								<div className="mt-8 flex items-center justify-between">
									{/* Dot indicators */}
									<div className="flex gap-2">
										{Array.from({
											length: Math.ceil(
												pressArticles.length / 3,
											),
										}).map((_, i) => (
											<button
												key={i}
												type="button"
												onClick={() =>
													setCarouselIndex(i)
												}
												aria-label={`Go to page ${i + 1}`}
												className={`h-2 rounded-full transition-all duration-300 ${
													i === carouselIndex
														? "w-6 bg-[#56BCF8]"
														: "w-2 bg-white/20 hover:bg-white/40"
												}`}
											/>
										))}
									</div>

									{/* Prev / Next buttons */}
									<div className="flex gap-3">
										<button
											type="button"
											onClick={() =>
												setCarouselIndex((i) =>
													Math.max(0, i - 1),
												)
											}
											disabled={carouselIndex === 0}
											aria-label="Previous articles"
											className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/6 text-white transition-all hover:bg-white/12 disabled:opacity-30 disabled:cursor-not-allowed"
										>
											&#8592;
										</button>
										<button
											type="button"
											onClick={() =>
												setCarouselIndex((i) =>
													Math.min(
														Math.ceil(
															pressArticles.length /
																3,
														) - 1,
														i + 1,
													),
												)
											}
											disabled={
												carouselIndex ===
												Math.ceil(
													pressArticles.length / 3,
												) -
													1
											}
											aria-label="Next articles"
											className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/6 text-white transition-all hover:bg-white/12 disabled:opacity-30 disabled:cursor-not-allowed"
										>
											&#8594;
										</button>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* <section
						className="flex w-full justify-center px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8 lg:pb-24"
						aria-label="Launch overview highlights"
					>
						<div className="w-full max-w-[1204px]">
							<div className="mx-auto max-w-[720px] text-center">
								<h2 className="m-0 text-[39px] font-bold leading-[1.08] tracking-[-0.03em] text-[#09152E] ">
									The people and perspectives shaping the
									VerifyTT launch
								</h2>
								<p className="mx-auto mb-0 mt-6 max-w-[680px] text-[16px] leading-[1.55] text-[#5B6475]">
									This page brings together the speakers,
									sessions, and key moments helping introduce
									VerifyTT and the opportunity behind it.
								</p>
							</div>

							<div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
								{launchHighlights.map(
									({ icon, alt, title, description }) => (
										<article
											key={title}
											className="rounded-[20px] border border-[#D6E3FF] bg-white p-6 transition-all duration-200 hover:border-[#116DFD80] hover:shadow-[0_8px_16px_#00000012]"
										>
											<div className="flex h-14 w-14 items-center justify-center rounded-[16px] bg-[#ECF3FF]">
												<img
													src={icon}
													alt={alt}
													className="h-6 w-6 object-contain"
												/>
											</div>
											<h3 className="mb-0 mt-8 text-[20px] font-bold leading-[1.22] tracking-[-0.02em] text-[#2C3443]">
												{title}
											</h3>
											<p className="mb-0 mt-4 text-[16px] leading-[1.55] text-[#6A7280]">
												{description}
											</p>
										</article>
									),
								)}
							</div>
						</div>
					</section> */}

					<section
						className="w-full bg-white"
						aria-label="Speaker lineup section"
					>
						<div className="flex w-full justify-center px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-24">
							<div className="w-full max-w-[1204px]">
								<div className="max-w-[900px]">
									<p className="m-0 text-[16px] font-semibold uppercase text-[#116DFD]">
										Speaker Lineup
									</p>
									<h2 className="mb-0 mt-4 text-[39px] font-bold leading-[1.08] tracking-[-0.03em] text-[#161F2F]">
										The people who led the conversation
									</h2>
								</div>

								<div
									className="mt-10 grid gap-5"
									style={{
										gridTemplateColumns:
											"repeat(auto-fit, minmax(250px, 1fr))",
									}}
								>
									{speakerLineup.map(
										({ id, name, role, image }) => (
											<article
												key={id}
												className="relative overflow-hidden rounded-[18px] border border-[#0F1B34] bg-[#09111F] p-6 text-white"
												style={{
													backgroundImage:
														"linear-gradient(rgba(53, 84, 140, 0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(53, 84, 140, 0.08) 1px, transparent 1px), linear-gradient(180deg, #0B1325 0%, #08111F 100%)",
													backgroundSize:
														"44px 44px, 44px 44px, cover",
													backgroundPosition:
														"0 0, 0 0, center",
												}}
											>
												<div
													className="absolute inset-x-0 top-0 h-[6px]"
													aria-hidden="true"
													style={{
														background:
															"linear-gradient(90deg, #EFBF04 0%, #EFBF04 18%, #56BCF8 50%, #367AE4 82%, #367AE4 100%)",
													}}
												/>
												<div className="flex h-[280px] items-center justify-center overflow-hidden rounded-[12px] bg-[#111A2C]">
													<img
														src={image}
														alt={name}
														className="h-full w-full object-contain"
													/>
												</div>

												<div className="px-1 pb-1 pt-5">
													<h3 className="m-0 text-[20px] font-bold leading-[1.2] tracking-[-0.02em] text-white">
														{name}
													</h3>
													<p className="mb-0 mt-2 text-[14px] leading-[1.45] text-[#56BCF8]">
														{role}
													</p>
												</div>
											</article>
										),
									)}
								</div>
							</div>
						</div>
					</section>

					<section
						ref={agendaSectionRef}
						className="flex w-full justify-center px-4 pb-16 pt-16 sm:px-6 sm:pb-20 sm:pt-20 lg:px-8 lg:pb-24 lg:pt-24 scroll-mt-28"
						aria-label="Launch agenda and closing note"
					>
						<div className="w-full max-w-[1204px]">
							{/* Heading — full width above cards */}
							<div className="max-w-[900px]">
								<p className="m-0 text-[16px] font-semibold uppercase text-[#116DFD]">
									Event Agenda
								</p>
								<h2 className="mb-0 mt-4 text-[39px] font-bold leading-[1.08] tracking-[-0.03em] text-[#161F2F]">
									What Happened On Launch Day
								</h2>
								<p className="mb-0 mt-5 max-w-[900px] text-[16px] leading-[1.55] text-[#333333]">
									A closer look at the key moments, featured
									speakers, and sessions from the day.
								</p>
							</div>

							{/* Two-column agenda — CSS grid equalises row heights; absolute divs provide the two-card visual */}
							<div className="relative mt-10">
								{/* Desktop card backgrounds — sit behind the grid items */}
								<div
									aria-hidden="true"
									className="pointer-events-none absolute inset-y-0 hidden rounded-[20px] border border-[#116DFD80] bg-white shadow-[0_10px_24px_rgba(15,23,42,0.05)] lg:block"
									style={{
										left: 0,
										right: "calc(50% + 12px)",
									}}
								/>
								<div
									aria-hidden="true"
									className="pointer-events-none absolute inset-y-0 hidden rounded-[20px] border border-[#116DFD80] bg-white shadow-[0_10px_24px_rgba(15,23,42,0.05)] lg:block"
									style={{
										left: "calc(50% + 12px)",
										right: 0,
									}}
								/>

								{/* Grid — single card on mobile, two-col equalised grid on desktop */}
								<div className="relative z-10 grid grid-cols-1 gap-4 rounded-[20px] border border-[#116DFD80] bg-white p-6 shadow-[0_10px_24px_rgba(15,23,42,0.05)] lg:border-0 lg:bg-transparent lg:shadow-none lg:p-6 lg:grid-cols-2 lg:gap-x-6 lg:gap-y-4 lg:[grid-auto-flow:column] lg:[grid-template-rows:repeat(6,auto)]">
									{launchAgenda.map(
										(
											{ number, title, description },
											index,
										) => (
											<article
												key={`${number}-${title}`}
												className={`grid grid-cols-[40px_minmax(0,1fr)] gap-4 rounded-[20px] border border-[#0000001A] bg-[#F9FAFB] p-5 transition-all duration-200 hover:border-[#116DFD80] hover:shadow-[0_8px_16px_#00000012] ${index < 6 ? "lg:mr-6" : "lg:ml-6"}`}
											>
												<div>
													<div className="text-[14px] font-bold leading-none text-[#116DFD]">
														{number}
													</div>
												</div>
												<div>
													<h3 className="m-0 text-[14px] font-bold uppercase leading-[1.35] text-[#0A111D]">
														{title}
													</h3>
													<p className="mb-0 mt-2 text-[14px] font-light leading-[1.55] text-[#0A111D]">
														{description}
													</p>
												</div>
											</article>
										),
									)}
								</div>
							</div>

							<ImageGallery
								images={eventGalleryImages}
								title="Moments From The Launch"
								subtitle="A look back at the people and highlights from the VerifyTT launch on April 22nd, 2026."
							/>

							{/* ── BOOK AN ONBOARDING CONSULTATION ── */}
							<section
								className="w-full flex justify-center mt-[60px]"
								aria-label="Book a demo"
							>
								<div
									className="w-full max-w-[1204px] bg-cover bg-center rounded-2xl overflow-hidden"
									style={{
										backgroundImage: `url(${trustBg})`,
									}}
								>
									<div className="vt-trust-demo-grid grid grid-cols-2 items-center p-[70px] gap-12">
										{/* Left: text content */}
										<div className="flex flex-col gap-4">
											<div className="text-[#116DFD] font-semibold text-base tracking-widest uppercase">
												BOOK AN ONBOARDING CONSULTATION
											</div>
											<div className="text-white text-[30px] font-bold leading-tight">
												See VerifyTT In Action?
											</div>
											<div className="text-white text-base leading-[1.7] max-w-[480px]">
												Discover how VerifyTT makes
												credentials secure, portable,
												and instantly verifiable. Book
												an onboarding consultation today
												and see how your organization
												can streamline verification with
												confidence.
											</div>
											<div className="mt-6">
												<a
													href="https://appointments.gov.tt/organizations/appointments/118.110"
													className="inline-block bg-white text-[#0f1623] font-bold text-[15px] px-8 py-[14px] rounded-[10px] no-underline"
												>
													Book Demo
												</a>
											</div>
										</div>
										{/* Right: graphic */}
										<div className="flex justify-center items-center">
											<img
												src={demoImg}
												alt="VerifyTT demo graphic"
												className="w-full max-w-[480px] h-auto object-contain"
											/>
										</div>
									</div>
								</div>
							</section>

							{/* <div className="mt-16 sm:mt-20 lg:mt-24">
								<div
									className="relative overflow-hidden rounded-[28px] border border-[#1B3E79] bg-[#0B1327] bg-cover bg-center bg-no-repeat px-24 py-32"
									style={{
										backgroundImage: `url(${closingCardBg})`,
									}}
								>
									<div
										className="absolute inset-x-0 top-0 h-[6px]"
										aria-hidden="true"
										style={{
											background:
												"linear-gradient(90deg, #EFBF04 0%, #EFBF04 16%, #56BCF8 50%, #367AE4 84%, #367AE4 100%)",
										}}
									/>
									<div className="relative z-10 max-w-[860px]">
										<p className="m-0 text-[16px] font-semibold uppercase tracking-[0.03em] text-[#116DFD]">
											A Note Of Thanks
										</p>
										<h2 className="mb-0 mt-3 text-[39px] font-bold leading-[1.12] tracking-[-0.03em] text-white">
											We Look Forward To Welcoming You
										</h2>
										<p className="mb-0 mt-5 max-w-[750px] text-[16px] leading-[1.6] text-white">
											Thank you for taking the time to
											join us for this important moment.
											We look forward to welcoming you and
											sharing the official launch of
											VerifyTT with you.
										</p>
									</div>
								</div>
							</div> */}
						</div>
					</section>
				</main>

				<Footer />
			</div>
		</div>
	);
};

export default SpeakerPage;
